<template>
    <l-modal :showing="showing" text="Edit Group" icon="edit" color="bg-black" @close="close">
        <div class="w-full text-xs">
            <div class="w-full flex">
                <div class="w-full">
                    <b>Name</b>
                    <br />
                    <l-input placeholder="Name" v-model="m_group.name" inputClass="text-2xs" />
                </div>
            </div>
            <div class="w-full flex mb-4"></div>
            <div class="w-full flex mb-4">
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Network</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="m_group.network">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Observations</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="m_group.observations">Read/Write</l-checkbox>
                    </div>
                </div>                
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Export</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="m_group.exporting">Read/Write</l-checkbox>
                    </div>
                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Quality control</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="m_group.qualitycontrol">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Processing</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="m_group.processing">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Users</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="m_group.users">Read/Write</l-checkbox>
                    </div>
                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-full">
                    <b>Networks</b>&nbsp;
                    <br />
                    <l-checkbox class="mr-4" v-model="m_group.allnetworks">All networks</l-checkbox>
                    <br />
                    <l-select2 v-if="!m_group.allnetworks" v-model="networkSelection" placeholder="Choose networks" :multiple="true" :options="networkSelectionList" :clearable="false" />

                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-full">
                    <b>Users</b>&nbsp;
                    <br />
                    <l-select2 v-model="m_selUsers" placeholder="Choose user(s)" :multiple="true" :options="users" :clearable="false" />

                </div>
            </div>

            <div class="flex w-full justify-between">
                <l-button type="success" @click="onSave">Save changes</l-button>
                <l-button type="danger" @click="close">Cancel</l-button>
            </div>
        </div>
    </l-modal>
</template>

<script>
    import LModal from "@/components/LModal";
    import { LInput, LButton, LSelect, LOption, LCheckbox, LSelect2 } from "@/components/forms";
    import GroupService from "./group.service";
    import Notify from "@/helpers/notify";

    export default {
        name: "LLEdit",
        props: ["showing", "selectedGroup", "selectedNetworks", "selectedUsers"],
        components: {
            LModal,
            LInput,
            LButton,
            LSelect,
            LOption,
            LCheckbox,
            LSelect2
        },
        data() {
            return {
            //    name: '',
            //     network: false,
            //     observations: false,
            //     exporting: false,
            //     processing: false,
            //     qualitycontrol: false,
            //     users: false,
            //     allnetworks: false,
                networkSelectionList: [],
                networkSelection: [],
                users: [],
                m_selUsers: [],
                m_group: {}
            };
        },
        mounted() {
            this.loadInitialData();
        },
        computed: {
        },
        watch: {
            selectedGroup: function (g) {
                console.log('selectedgroup', g)
                this.m_group = g;
            },
            selectedNetworks: function (s) {
                this.networkSelection = s;
            },
            selectedUsers: function (u) {
                this.m_selUsers = u;
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
            async onSave() {
                this.m_group.networkIds = this.networkSelection;
                this.m_group.userIds = this.m_selUsers;
                await Notify.loadData("Saving changes for '" + this.m_group.name + "'", GroupService.updateGroup, this.m_group);
                this.$emit("save", this.selectedGroup);
                this.close();
            },
            async loadInitialData() {
                this.networkSelectionList = await GroupService.networkSelectList();
                this.users = await GroupService.users();
            },
        }
    };
</script>